import {MeinText} from '@components/@typography/MeinText';
import {formatTime} from '@utils/formatTime';
import {useState} from 'react';
import {useVideoPlayerState} from '../../useVideoPlayer';
import {VideoControlsItem} from '../Item/VideoControlsItem';
import styles from './VideoTimeButton.module.css';

export const VideoTimeButton = () => {
    const [showNegativeTime, setShowNegativeTime] = useState(false);
    const currentTime = useVideoPlayerState(s => s.currentTime);
    const duration = useVideoPlayerState(s => s.duration);

    if (
        Number.isNaN(duration) ||
        Number.isNaN(currentTime) ||
        duration === Infinity ||
        duration === -Infinity
    ) {
        return null;
    }

    const formattedTime =
        formatTime(currentTime) + ' / ' + formatTime(duration);

    const formattedNegativeTime =
        '-' + formatTime(duration - currentTime) + ' / ' + formatTime(duration);

    const handleTimeClick = () => {
        setShowNegativeTime(isShowing => !isShowing);
    };

    return (
        <VideoControlsItem onClick={handleTimeClick}>
            <div className={styles.timeTextContainer}>
                <MeinText size="m" className={styles.timeText}>
                    {showNegativeTime ? formattedNegativeTime : formattedTime}
                </MeinText>
            </div>
        </VideoControlsItem>
    );
};
